// is variable defined?
function isDefined(prom) {
    return ((prom !== undefined) && (typeof prom !== typeof undefined));
}

// is variable object?
function isObject(prom)
{
    if(isDefined(prom)) {if (typeof prom === 'object') {return true;}}
    return false;
}

// is variable bool?
function isBoolean(prom)
{
    if(isDefined(prom)) {if (typeof prom === "boolean") {return true;}}
    return false;
}

// is variable function?
function isFunction(prom){
    if(isDefined(prom)) {if (typeof prom === 'function') {return true;}}
    return false;
}

// generate uniq id
function uniqid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

// Get document real height
function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}

// Get real container height
function getContainerHeight(element, byElementsInside) {
    if (!isDefined(byElementsInside)) {
        byElementsInside = false;
    }
    if (byElementsInside) {
        var total = 0;
        element.children().each(function() {
            if($(this).is(":visible")) {
                total += $(this).outerHeight();
            }
        });
        return total;
    } else {
        return element.outerHeight(true);
    }
}

// files operations
function loadImageFromFile(file, callback) {
    var reader = new FileReader(file);
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        var img = new Image();
        var origH;
        var origW;
        img.src = e.target.result;
        img.onload = function () {
            origH = this.height;
            origW = this.width;
            if (origH > origW) {
                img.height = 150;
            }
            callback(img);
        };
    }
}

/* Change default options to defined options */

function parseOptions(options_def, options_new) {

    $.each(options_new, function (property, value) {
        $.each(options_def, function (prop, val) {
            if (prop === property) {
                if(!isDefined(val) && isDefined(value)){
                    options_def[prop] = value;
                } else {
                    if (isObject(val) && isObject(value)) {
                        parseOptions(val, value);
                    } else {
                        if (isObject(val) && !isObject(value)) {
                            console.log("Wrong option value, it must be object: " + prop + "");
                        } else {
                            if(isDefined(value)) {
                                if (value === "true" || value === "false") {
                                    options_def[prop] = (value === 'true');
                                } else {
                                    if (value !== "") {
                                        options_def[prop] = value;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    });
}

(function ($) {

    $.fn.batchImageLoad = function (options) {
        var images = $(this);
        var originalTotalImagesCount = images.length;
        var totalImagesCount = originalTotalImagesCount;
        var elementsLoaded = 0;

        // Init
        $.fn.batchImageLoad.defaults = {
            loadingCompleteCallback: null,
            imageLoadedCallback: null
        };

        var opts = $.extend({}, $.fn.batchImageLoad.defaults, options);

        // Start
        images.each(function () {
            if ($(this)[0].complete) {
                totalImagesCount--;
                if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                // The image is loading, so attach the listener
            } else {
                $(this).on('load', function () {
                    elementsLoaded++;
                    if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                    // An image has been loaded
                    if (elementsLoaded >= totalImagesCount)
                        if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
                });
                $(this).on('error', function () {
                    elementsLoaded++;
                    if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                    // The image has errored
                    if (elementsLoaded >= totalImagesCount)
                        if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
                });
            }
        });
        // There are no unloaded images
        if (totalImagesCount <= 0)
            if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
    };

    $.fn.centerIntoParent = function (parent) {

        var elem = $(this);

        if (!isDefined(parent.css("position"))) {
            parent.css({"position": "relative"});
        }

        function reposition() {
            var parenTop = parent.offset().top;
            var parentHeight = getContainerHeight(parent);
            var parentWidth = parent.outerWidth(true);
            var winTop = $(window).scrollTop();
            var winHeight = $(window).height();
            var elemHeight = getContainerHeight(elem);
            var elemWidth = elem.outerWidth(true);
            var visible;
            var cut;
            var top = 0;

            if (winTop < parenTop) {
                cut = 0;
                if ((winTop + winHeight) >= parenTop) {
                    if ((winTop + winHeight) > (parenTop + parentHeight)) {
                        visible = winHeight - (parenTop - winTop) - ((winTop + winHeight) - (parenTop + parentHeight));
                    } else {
                        visible = winHeight - (parenTop - winTop);
                    }
                } else {
                    visible = 0;
                }
                if (visible > 0) {
                    if (visible > elemHeight) {
                        top = cut + (visible / 2) - elemHeight / 2;
                    }
                }
            } else {
                top = parentHeight - elemHeight;
                if (winTop <= parenTop + parentHeight) {
                    cut = winTop - parenTop;
                    if ((winTop + winHeight) > (parenTop + parentHeight)) {
                        visible = winHeight - ((winTop + winHeight) - (parenTop + parentHeight));
                    } else {
                        visible = winHeight;
                    }
                } else {
                    visible = 0;
                }
                if (visible > 0) {
                    if (visible > elemHeight) {
                        top = cut + (visible / 2) - elemHeight / 2;
                    }
                }
            }

            var left = (parentWidth / 2) - (elemWidth / 2);

            elem.css({
                "position": "absolute",
                "top": top,
                "left": left
            });
        }

        $(window).scroll(function () {
            reposition();
        });

        reposition();
    };

    $.fn.centerToScreen = function () {
        var elem = $(this);
        elem.css({
            "position": "fixed",
            "top": ($(window).height() / 2 - getContainerHeight($(this)) / 2),
            "left": ($(window).width() / 2 - $(this).outerWidth(true) / 2)
        });
    };

})(jQuery);